export const nickname = (topic: MQTTValue["topic"] | undefined): string => {
  if (!topic) return "---";
  return topic.nickname || topic.topic;
};
